module.exports = __webpack_public_path__ + "static/coronacamp-dcaa8c3da03fa45ed27898a974134379.svg";